import request from '@/utils/request'

//轮播图
export function bannerList() {
  return request({
    url: `/banner/list`,
    method: 'post',
  })
}
//查询所有菜单
export function menuAll() {
  return request({
    url: `/menu/listAll`,
    method: 'get',
  })
}
//查询一级菜单/二级菜单
export function menu(parentId) {
  return request({
    url: `menu/list?parentId=${parentId}`,
    method: 'get',
  })
}
//富文本
export function singleinfo(id) {
  return request({
    url: `singleInfo/${id}`,
    method: 'get',
  })
}
//列表不分页
export function contentList(menuId) {
  return request({
    url: `content/list?menuId=${menuId}`,
    method: 'get',
  })
}
//列表分页
export function contentPage(pageNum, pageSize, menuId, search, contentSort,type,img,contentType,awardLevel) {
  if (!type) {
    type = ''
  }
  if (!search) {
    search = ''
  }
  if (!contentSort) {
    contentSort = ''
  }
  if (!img) {
    img = 0
  }
  
  if (!contentType) {
    contentType = ''
  }
  if (!awardLevel) {
    awardLevel = ''
  }
  return request({
    url: `content/page?pageNum=${pageNum}&pageSize=${pageSize}&menuId=${menuId}&search=${search}&contentSort=${contentSort}&type=${type}&img=${img}&contentType=${contentType}&awardLevel=${awardLevel}`,
    method: 'get',
  })
}
//翻页
export function flipping(menuId,id){
  return request({
    url: `content/detailed/page?menuId=${menuId}&id=${id}`,
    method: 'get',
  })
}

//查询业务领域列表
export function businessList() {
  return request({
    url: `business/list`,
    method: 'get',
  })
}
//业务领域详情
export function businessDetail(id) {
  return request({
    url: `business/${id}`,
    method: 'get',
  })
}

//业务领域-模块一列表
export function businessOneList(id) {
  return request({
    url: `business/one/type/list/?pageNum=${1}&pageSize=${100}&businessId=${id}&contentSort=1`,
    method: 'get',
  })
}

//业务领域-模块一详情
export function businessOne(id='') {
  return request({
    url: `business/one/list/?businessId=${id}`,
    method: 'get',
  })
}

//业务领域-模块二
export function businessTwo(id) {
  return request({
    url: `business/two/list/?businessId=${id}`,
    method: 'get',
  })
}

//业务领域-模块三
export function businessThree(id) {
  return request({
    url: `business/three/list/?businessId=${id}`,
    method: 'get',
  })
}
//联系我们
export function contactUs() {
  return request({
    url: `unit/up/list`,
    method: 'get',
  })
}

//友情链接
export function unitList() {
  return request({
    url: `unit/list`,
    method: 'get',
  })
}

//下属企业列表
export function unitBelowList() {
  return request({
    url: `unit/unit/below/list`,
    method: 'get',
  })
}

//首页产品列表
export function CmsProductList() {
  return request({
    url: `cmsProduct/list`,
    method: 'get',
  })
}

//字典列表
export function DictList(dictType) {
  return request({
    url: `dict/data/list?dictType=${dictType}`,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js